module.exports = __webpack_public_path__ + "media/ads/fire-dd2e9f02.png";